var VolumePromotion = /** @class */ (function () {
    function VolumePromotion(obj, id) {
        if (id) {
            this.id = id;
        }
        this.name = obj.name;
        this.begin_date = obj.begin_date;
        this.end_date = obj.end_date;
    }
    Object.defineProperty(VolumePromotion.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumePromotion.prototype, "BeginDate", {
        get: function () {
            return this.begin_date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumePromotion.prototype, "Name", {
        get: function () {
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumePromotion.prototype, "EndDate", {
        get: function () {
            return this.end_date;
        },
        enumerable: false,
        configurable: true
    });
    return VolumePromotion;
}());
export { VolumePromotion };
export function createVolumePromotion(obj, id) {
    return new VolumePromotion(obj, id);
}
export function createVolumePromotions(volumePromotions) {
    var slides = [];
    var rawVolumePromotions = volumePromotions.data;
    for (var _i = 0, rawVolumePromotions_1 = rawVolumePromotions; _i < rawVolumePromotions_1.length; _i++) {
        var rawVolumePromotion = rawVolumePromotions_1[_i];
        var slide = createVolumePromotion(rawVolumePromotion.attributes, rawVolumePromotion.id);
        slides.push(slide);
    }
    return slides;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/volumePromotion/volumePromotion.ts
// module id = 139
// module chunks = 0